"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointCache = exports.PointCacheImpl = void 0;
var PointCacheImpl = /** @class */ (function () {
    function PointCacheImpl() {
        this.cache = {};
        this.projection = null;
    }
    PointCacheImpl.prototype.reset = function () {
        this.cache = {};
    };
    PointCacheImpl.prototype.setProjection = function (projection) {
        this.projection = projection;
    };
    PointCacheImpl.prototype.getGeoPoint = function (loc) {
        return this.getPoint(loc.coordinates[1], loc.coordinates[0]);
    };
    PointCacheImpl.prototype.getPoint = function (lat, lng) {
        var cacheKey = "".concat(lat, ":").concat(lng);
        var point = this.cache[cacheKey];
        if (this.projection == null) {
            return null;
        }
        if (point == null && this.projection != null) {
            var latLng = new google.maps.LatLng(lat, lng);
            point = this.cache[cacheKey] = this.projection.fromLatLngToDivPixel(latLng);
        }
        return point;
    };
    return PointCacheImpl;
}());
exports.PointCacheImpl = PointCacheImpl;
exports.PointCache = new PointCacheImpl();
//# sourceMappingURL=projection.cache.js.map